import { WebScoreService } from './web';
export default WebScoreService;
